import { render } from "./matches.vue?vue&type=template&id=b19cceb8&scoped=true"
import script from "./matches.vue?vue&type=script&lang=js"
export * from "./matches.vue?vue&type=script&lang=js"

import "./matches.vue?vue&type=style&index=0&id=b19cceb8&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0cc0aef14303b400c-1/assemble-sports/singaporerugby-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19cceb8"]])

export default __exports__